import moment from "moment";

/**
 * Function returning the build date(as per provided epoch)
 * @param {number} epoch Time in milliseconds
 * @return {string} The string format of given time
 */
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("DD-MM-YYYY HH:MM");
  return buildDate;
};
